import JobReducer from "./job/reducer";
import JobFormReducer from "./jobForm/reducer";
import JobListReducer from "./jobList/reducer";
import JobStageReducer from "./jobStage/reducer";
import TosReducer from "./tos/reducer";
import PreAssessmentReducer from "./preAssessment/reducer";
import PreOfferCandidateReducer from "./preOfferVerfication/reducer";

export {
  JobReducer,
  JobFormReducer,
  JobListReducer,
  JobStageReducer,
  TosReducer,
  PreAssessmentReducer,
  PreOfferCandidateReducer,
};
